export default __webpack_public_path__ + "static/media/water.9cb690a0.png";